import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';
import Layout from '../../components/Layout';
import i18n from '../../i18n';
import ContactGrid from '../../components/Contacts/ContactGrid';
import Toolbar from '../../components/Toolbar/Toolbar';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SearchForm from '../../components/Contacts/SearchForm';
import {getText} from '../../components/Contacts/transforming';
import {urlQuery} from '../../components/Form/utils';

const ContactsIndex = ({classes, contacts, contactType, search, order, column}) => {

    const [isTable, setIsTable] = useState(true);
    const [state, setState] = useState({
        checked: true,
    });

    const handleChange = name => event => {
        setState({...state, [name]: event.target.checked});
    };

    const changeTable = () => {
        setIsTable(!isTable);
    };

    // console.log(contacts)

    const {title, subtitle, btnAddText} = getText(contactType, contacts.total);

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={title}
                subtitle={subtitle}
                items={[
                    {
                        icon: 'add',
                        text: btnAddText,
                        href: `/contacts/${contactType}s/create`,
                        size: 'small',
                    },
                ]}

            >
                <span className={classes.switch}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={state.checked}
                                onChange={handleChange('checked')}
                                value="checked"
                                color="primary"
                                onClick={changeTable}
                            />
                        }
                        label={i18n.get('contacts.table.label')}
                    />
                </span>

            </Toolbar>

            <SearchForm url={`/contacts/search/${contactType}s`} {...search} />

            <ContactGrid contacts={contacts} contactType={contactType} isTable={isTable} order={order} column={column} paramsQuery={urlQuery(search)}/>
        </Layout>
    );
};

const styles = theme => ({
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    switch: {
        display: 'block',
        [theme.breakpoints.only('xs')]: {
            display: 'none',
        },
        marginLeft: '10px',
    },

});

export default withStyles(styles)(ContactsIndex);
